export enum QueryParams {
  LIMIT = 'limit',
  OFFSET = 'offset',
  FILTER_BY = 'filter_by',
  ORDER_BY = 'order_by',
  SORT_BY = 'sort_by',
}
